import {
  MAX_MATRIX_CATEGORIES as SHARED_MAX_MATRIX_CATEGORIES,
  MAX_MATRIX_MEASURES as SHARED_MAX_MATRIX_MEASURES,
  RESEARCH_QUESTION_CEILING as SHARED_RESEARCH_QUESTION_CEILING,
} from "@digital-twins/shared-types";

/**
 * Frontend mirror for authoring guards and copy only.
 *
 * Review and compile eligibility always come from backend readiness; question
 * count and this ceiling must never be used to derive either verdict.
 */
export const QUESTIONNAIRE_RESEARCH_QUESTION_CEILING =
  SHARED_RESEARCH_QUESTION_CEILING;

export const QUESTIONNAIRE_MAX_MATRIX_MEASURES = SHARED_MAX_MATRIX_MEASURES;
export const QUESTIONNAIRE_MAX_MATRIX_CATEGORIES = SHARED_MAX_MATRIX_CATEGORIES;
